import { string } from 'yup';

const rule = {
	name: 'partialCreditCardNumber',
	method ({ message } = { message: 'Please re-enter your credit card number and expiration date.' }) {

		return this.test('partialCreditCardNumber', message, function (value) {

			const { createError } = this;
			return !/xxxx-xxxx-xxxx/i.test(value) || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
